import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M735.385333,336.093725 C953.625073,336.093725 1131.36205,513.717567 1131.36205,732.070443 L1131.36205,732.070443 L1131.36205,845.206648 C1131.36205,967.167477 1074.79395,1074.98628 987.792207,1147.73286 C1081.92153,1161.64861 1175.14576,1182.69195 1266.10727,1212.33363 C1388.52065,1252.15758 1470.77067,1368.00905 1470.77067,1500.49155 L1470.77067,1500.49155 L1470.77067,1700.85577 L1443.95739,1717.48679 C1295.52268,1809.80593 1051.94044,1920.0006 735.385333,1920.0006 C560.589896,1920.0006 295.624904,1884.81524 26.7001444,1717.48679 L26.7001444,1717.48679 L0,1700.85577 L0,1511.46576 C0,1370.83746 89.2644659,1248.42408 221.973234,1206.67682 C307.391069,1179.97668 394.505947,1160.17784 482.299642,1147.16718 C395.750446,1074.4206 339.408615,966.828068 339.408615,845.206648 L339.408615,845.206648 L339.408615,732.070443 C339.408615,513.717567 517.032457,336.093725 735.385333,336.093725 Z M1183.40471,0 C1401.64445,0 1579.38142,177.623842 1579.38142,395.976718 L1579.38142,395.976718 L1579.38142,509.112923 C1579.38142,631.073752 1522.81332,739.005692 1435.81158,811.639136 C1529.9409,825.554889 1623.052,846.711359 1714.12664,876.239909 C1836.54002,916.290125 1918.79004,1032.02846 1918.79004,1164.51096 L1918.79004,1164.51096 L1918.79004,1364.87518 L1892.08989,1381.5062 C1814.47846,1429.81536 1710.28001,1482.53683 1583.90687,1522.24764 L1583.90687,1522.24764 L1583.90687,1500.52549 C1583.90687,1318.82874 1470.31812,1159.75924 1301.1795,1104.77504 C1264.74964,1092.89574 1227.64096,1082.1478 1189.6272,1072.53122 C1225.37824,1002.72619 1244.49826,925.114749 1244.49826,845.240589 L1244.49826,845.240589 L1244.49826,732.104383 C1244.49826,481.620825 1062.4621,274.129025 824.084118,231.929221 C886.761576,95.4869571 1023.65638,0 1183.40471,0 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconGroupSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconGroupSolid, _Component);

  var _super = _createSuper(IconGroupSolid);

  function IconGroupSolid() {
    _classCallCheck(this, IconGroupSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconGroupSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconGroup",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconGroupSolid.displayName = "IconGroupSolid";
  return IconGroupSolid;
}(Component);

IconGroupSolid.glyphName = 'group';
IconGroupSolid.variant = 'Solid';
IconGroupSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconGroupSolid;
export { IconGroupSolid };